import React from 'react'

interface Row {
  id: number | string;
  name: string;
}

interface ActionsProps {
  row: Row;
  editingId: number | string | null;
  saveButton: React.ReactNode;
  cancelButton: React.ReactNode;
  editButton: React.ReactNode;
  deleteButton: React.ReactNode;
}

export const Actions: React.FC<ActionsProps> = ({
  row,
  editingId,
  saveButton,
  cancelButton,
  editButton,
  deleteButton
}) => {
  return (
    <div>
      {editingId === row.id ? (
        <>
          {saveButton}
          {cancelButton}
        </>
      ) : (
        <>
          {editButton}
          {deleteButton}
        </>
      )}
    </div>
  )
}
